import api from "../config/api/axiosConfig";

export const useAllergenApi = () => {
  const getAllergens = async () => {
    const response = await api.get("/Allergen");
    return response;
  };

  const createAllergen = async (name: string) => {
    const response = await api.post("/Allergen", { name });
    return response;
  };

  return {
    getAllergens,
    createAllergen,
  };
};
